<div
    [ngClass]="{
        'loading-screen d-flex flex-column justify-content-center align-items-center text-light h-100 w-100 rounded-2': true,
        'bg-filter': status !== 'success',
        'border border-success': status === PROCESSING_STATE.SUCCESS,
        'border border-danger': status === PROCESSING_STATE.ERROR
    }"
>
    <div *ngIf="status === PROCESSING_STATE.PENDING || status === PROCESSING_STATE.PARSING" class="w-100">
        <div class="progress progress-bar-step">
            <div
                class="progress-bar bg-info"
                role="progressbar"
                [style.width.%]="progress"
                [attr.aria-valuenow]="progress"
                aria-valuemin="0"
                aria-valuemax="100"
            ></div>
        </div>
        <p class="text-center mt-2 mb-0">{{ loadingMessage }}</p>
    </div>

    <div *ngIf="status === PROCESSING_STATE.ERROR">
        <div class="p-3 bg-danger rounded-circle">
            <img
                src="/img/icons/error-triangle-exclamation.svg"
                alt="error triangle exclamation"
                width="25"
                height="25"
            />
        </div>
    </div>
</div>
